import type { ShoppingCoupon } from '@redd/contracts';
import { couponEligibleForPurchase, purchaseCouponLabel } from './coupon-presentation';

type Props = {
  coupons: ShoppingCoupon[];
  selectedId: string | undefined;
  priceFen: number;
  disabled: boolean;
  loading: boolean;
  error: string;
  onSelect: (id: string | undefined) => void;
  onRetry: () => void;
};

export function PurchaseCouponPicker({ coupons, selectedId, priceFen, disabled, loading, error, onSelect, onRetry }: Props) {
  const eligible = coupons.filter(coupon => couponEligibleForPurchase(coupon, priceFen));
  return <section className="purchase-coupons" aria-label="选择购货优惠券">
    <fieldset disabled={disabled || loading}>
      <legend>购货优惠券 · 每单限用一张</legend>
      <label className="purchase-coupon-option">
        <input type="radio" name="purchase-coupon" checked={!selectedId} onChange={() => onSelect(undefined)}/>
        <span>不使用优惠券</span>
      </label>
      {eligible.map(coupon => <label className="purchase-coupon-option" key={coupon.id}>
        <input type="radio" name="purchase-coupon" checked={selectedId === coupon.id} onChange={() => onSelect(coupon.id)}/>
        <span><strong>{purchaseCouponLabel(coupon)}</strong><small>有效期至 {new Date(coupon.expiresAt).toLocaleString('zh-CN', { hour12: false })}</small></span>
      </label>)}
    </fieldset>
    {loading ? <p role="status">正在读取优惠券…</p> : error ? <p role="status">{error} <button type="button" disabled={disabled} onClick={onRetry}>重新读取</button></p> : !eligible.length ? <p>当前没有适用于此商品的购货优惠券。</p> : null}
    {eligible.some(coupon => coupon.source === 'membership') && <p>会员购货券无最低消费门槛，仅用于直接购买单件商品，最高抵扣券面金额；不与其他券叠加，使用后剩余额度作废，在对应会员周期结束时到期。</p>}
  </section>;
}
